import { render, staticRenderFns } from "./ExportSchoolContacts.vue?vue&type=template&id=2ed52828&"
import script from "./ExportSchoolContacts.vue?vue&type=script&lang=js&"
export * from "./ExportSchoolContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports